import { ActiveTab, BulkAction, Pagination, Search } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";
import urlJoin from "url-join";

export const expressFleetConfigSection = "/express-fleet/";
export const expressFleetOpsPage = "/express-fleet-ops/";

export const expressFleetConfigListUrl = expressFleetConfigSection;
export const expressFleetOpsPageUrl = expressFleetOpsPage;

export const expressFleetUrl = (params?: any): string => {
  const expressFleetListUrl = expressFleetConfigListUrl;
  if (params === undefined) {
    return expressFleetListUrl;
  } else {
    return urlJoin(expressFleetConfigListUrl, "?" + stringifyQs(params));
  }
};

export const expressFleetOpsUrl = (params?: any): string => {
  const _expressFleetOpsUrl = expressFleetOpsPageUrl;
  if (params === undefined) {
    return _expressFleetOpsUrl;
  } else {
    return urlJoin(expressFleetOpsPageUrl, "?" + stringifyQs(params));
  }
};

export type ExpressFleetListUrlQueryParams = BulkAction &
  ActiveTab &
  Pagination & {
    mall?: string;
    search?: string;
  } & Search;
